/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"
import * as wjrInput from "@grapecity/wijmo.react.input"

// other
import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import CONSTANT from "../../../constant"
import VacationService from "../../../service/attendance/vacation/vacationService"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import { ModalOuter, TModalTypes } from "./VacationModalOuter"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { showInfoToast } from "../../../components/CustomToast"
import Spinner from "../../../components/Spinner"

import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import { 区分分類コード, 社員_乗務員 } from "../../../constant/enum/codes"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import ComboBox from "../../../components/ComboBox"
import KubunService from "../../../service/master/kubun/kubunService"
import { e入社区分 } from "../../../constant/enum/syain"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import dateUtil from "../../../ts/util/dateUtil"
import { TYyukyuHuyoGetRes } from "../../../service/attendance/vacation/TVacation"
import lodash from "lodash"
import SystemService from "../../../service/system/systemService"

/**
 * 有給取得（個人）一覧モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const VacationHuyoModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    successHandler?: () => void
  }
> = (props) => {
  //#region [state]
  // 検索項目
  const [年度, set年度] = useState<number>()

  // 登録用
  const [有休付与区分コード, set有休付与区分コード] = useState<string | null>()

  // combobox
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  // 有休付与区分
  const [有休付与区分ComboBox, set有休付与区分ComboBox] =
    useState<TWijmoComboBox<T区分マスタ["区分コード"], T区分マスタ> | null>(
      null
    )
  const [有休付与区分IsLoadEnded, set有休付与区分IsLoadEnded] =
    useState<boolean>(false)

  // Grid
  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()

  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  // 確認メッセージモーダル用
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  /**
   * 履歴読込処理
   */
  const loadHistory = async () => {
    setAlertSource(undefined)

    try {
      const res = await new VacationService().getHuyoList()

      // 検索結果をstateにセット
      const newData = createCollectionView([...res.data])
      flexGrid!.itemsSource = newData
      setGridData({ data: newData })
      flexGrid!.refresh()

      return res.data
    } catch (error) {
      setAlertSource(error)
      return []
    } finally {
    }
  }

  const createCollectionView = (data: Array<any>) =>
    new wjcCore.CollectionView(data, {})

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([]),
  })

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装

    setIsConfirmModalShow(true)
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      const res = await new VacationService().postHuyoList({
        付与年度: 年度!,
        有休付与区分コード: 有休付与区分コード ?? "",
      })
      setAlertSource(res)
      if (res) {
        showInfoToast(`有給付与処理の登録が完了しました`)
        props.setIsShow(false)

        // 成功時ハンドラ呼び出し
        if (props.successHandler) props.successHandler()
      }
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [effect]
  useEffect(() => {
    if (flexGrid == null || 有休付与区分ComboBox == null) return

    if (props.isShow) {
      setIsSpinnerShow(true)

      // 表示時処理
      Promise.all([
        new SystemService().getNendo(),
        new KubunService().getList({ 分類コード: 社員_乗務員.入社区分 }),
        loadHistory(),
      ]).then(([年度Res, 入社区分Res, loadHistoryRes]) => {
        set区分ItemSource(入社区分Res.data)

        const 処理月コードリスト = 入社区分Res.data
          .map((v) => v.区分コード)
          .filter((v) => v !== e入社区分.付与対象外)

        // 履歴の最大年度算出
        const 履歴最大年度Res = lodash.maxBy(
          loadHistoryRes,
          (item) => item.年度
        )
        const 履歴最大年度の処理済付与月コードリスト = loadHistoryRes
          .filter((v) => v.年度 === 履歴最大年度Res?.年度)
          .map((v) => v.付与月区分コード)

        // 未処理付与月がある場合はその年度、全て処理済みの場合は次年度を設定しておく
        const has未処理付与月 = 処理月コードリスト.some(
          (c) => !履歴最大年度の処理済付与月コードリスト.includes(c)
        )
        if (has未処理付与月) {
          set年度(履歴最大年度Res?.年度 ?? 年度Res.data)
        } else {
          set年度(
            履歴最大年度Res != null ? 履歴最大年度Res.年度 + 1 : 年度Res.data
          )
        }

        setIsSpinnerShow(false)
      })
    } else {
      // 非表示時中身を空にして閉じる
      // set年度(0)
      const newData = {
        data: createCollectionView([]),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setGridData(newData)
    }
  }, [props.isShow, flexGrid, 有休付与区分ComboBox])

  //#endregion

  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "有給付与処理"}
      setIsShow={props.setIsShow}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <Row>
          <Col>
            <h5>有休残の繰越および付与処理を行います</h5>
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <Container fluid className="register-form">
                <MasterRegisterFormRow
                  label="対象年度"
                  isRequired={true}
                  isRemarks={false}>
                  <wjrInput.InputNumber
                    style={{ width: "5rem" }}
                    id="年度"
                    name="年度"
                    format={"g0"}
                    isRequired={true}
                    isReadOnly={true}
                    value={年度}
                  />
                </MasterRegisterFormRow>
                <MasterRegisterFormRow
                  label="対象付与月"
                  isRequired={true}
                  isRemarks={false}>
                  <ComboBox.Kubun
                    autoFocus={true}
                    分類コード={区分分類コード.社員_乗務員.入社区分}
                    isLoadEnded={有休付与区分IsLoadEnded}
                    setIsLoadEnded={set有休付与区分IsLoadEnded}
                    isAllSelect={false}
                    isRequired={true}
                    itemsSource={区分ItemSource}
                    listFilter={(item) =>
                      item.区分コード !== e入社区分.付与対象外
                    }
                    selectedValue={有休付与区分コード}
                    setSelectedValue={set有休付与区分コード}
                    ComboBox={有休付与区分ComboBox}
                    setComboBox={set有休付与区分ComboBox}></ComboBox.Kubun>
                </MasterRegisterFormRow>
                <Row className="search-button mt-2">
                  <Col xl={12} className="text-end">
                    <Button
                      variant="waiting"
                      type="submit"
                      onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        beforeSubmit()
                      }}>
                      登録
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </form>
        <Row>
          <Col>
            <h5>実行履歴</h5>
          </Col>
        </Row>
        <Row>
          <Col style={{ height: "auto" }}>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              style={{ height: "auto" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                dataType={wjcCore.DataType.Number}
                format="d"
                width={100}
                header="前回年度"
                binding="年度"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={100}
                header="付与月"
                binding="付与月区分名称1"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={150}
                header="付与処理日時"
                binding="実行日時">
                <wjrGrid.FlexGridCellTemplate
                  cellType="Cell"
                  template={(
                    context: TWijmoCellTemplateContext<TYyukyuHuyoGetRes>
                  ) => {
                    return (
                      <>
                        {dateUtil.format(
                          context.item.実行日時,
                          "YYYY/MM/DD HH:mm"
                        )}
                      </>
                    )
                  }}
                />
              </wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        登録しますか？
      </ConfirmModal>
    </ModalOuter>
  )
}

export default VacationHuyoModal
